module.exports = "./img/e1ab3a88edde831a4a69c985c8f6809f.jpg";